import { render, staticRenderFns } from "./DetailKTDialog.vue?vue&type=template&id=a1320004&scoped=true"
import script from "./DetailKTDialog.vue?vue&type=script&lang=js"
export * from "./DetailKTDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailKTDialog.vue?vue&type=style&index=0&id=a1320004&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1320004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1320004')) {
      api.createRecord('a1320004', component.options)
    } else {
      api.reload('a1320004', component.options)
    }
    module.hot.accept("./DetailKTDialog.vue?vue&type=template&id=a1320004&scoped=true", function () {
      api.rerender('a1320004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/ExcelTableDialog/DetailKTDialog.vue"
export default component.exports